module.exports = __webpack_public_path__ + "img/impuestos.d31e27ad.jpg";